/**
 *
 * ActionPlanTask
 *
 */

import React, { Fragment } from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import "./index.less"
import {
  Checkbox,
  Popover,
  Dropdown,
  Menu,
  Spin,
  Tooltip,
  Avatar,
} from "antd"
import { Icon } from "@ant-design/compatible"
import pointMenu from "images/three-points-gray.svg"
import moment from "moment"
import ProgressBar from "../ProgressBar"
import ActionPlanTaskForm from "../ActionPlanTaskForm"
import {
  CalendarOutlined,
  CalendarFilled,
  CalendarTwoTone,
} from "@ant-design/icons"
import { loadTexts, sanitize } from "../../utils/i18n"
/* eslint-disable react/prefer-stateless-function */
class ActionPlanTask extends React.Component {
  intl = loadTexts("dashboard")
  state = {
    editMode: false,
    employees: [],
  }

  loadDetailsToEditTask = async () => {
    this.setState({
      task_create: true,
      task_loading_details: true,
    })
    try {
      const items = await fetchGlobalApi({
        method: "GET",
        endpoint: `action-plans/${this.props.actionPlan.id_action_plan}/tasks/${this.props.data.id_task}/edit`,
      })
      this.setState(
        {
          task_loading_details: false,
          employees: items.data.data.result.employees,
        },
        () => {
          this.setCurrentEmployeeToEmployees(
            items.data.data.result.task.employees[0]
          )
        }
      )
    } catch (error) {
      this.setState({ task_loading_details: false })
    }
  }

  setCurrentEmployeeToEmployees = (item) => {
    if (!item) return false
    const { employees } = this.state
    const verifyExist = employees.find(
      (e) => e.id_employee === item.id_employee
    )
    if (!verifyExist) {
      item.picture_profile = item.profile_picture
      employees.unshift(item)
    }
    this.setState({ employees })
  }

  updateTaskStatus = async (type = 1, id, done = 1) => {
    done = done ? 1 : 0
    let url = `tasks/${id}/done`
    if (type === 2) {
      url = `tasks-schedules/${id}/done`
    }
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: url,
        data: { done: done }
      })
      this.props.onUpdateActionPlan(result.data.data.result)
    } catch (error) {
      returnMessage(error)
    }
  }

  render() {
    const {
      actionPlan,
      data,
      data: { task_schedules },
      onUpdateTask,
      canEdit,
    } = this.props
    const { editMode, task_loading_details, employees } = this.state
    if (editMode && task_loading_details) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }

    const canChangeStatus =
      actionPlan.editable || validRole({ role: [1, 2, 3, 4,5] }) || data.editable

    if (editMode) {
      data.date_start = data.date_start
        ? moment(data.date_start, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
            "YYYY-MM-DD"
          )
        : null
      data.date_end = data.date_end
        ? moment(data.date_end, ["DD-MM-YYYY", "YYYY-MM-DD"]).format(
            "YYYY-MM-DD"
          )
        : null
      return (
        <ActionPlanTaskForm
          style={{
            paddingTop: 10,
            paddingBottom: 20,
            border: 0,
            borderBottom: "1px solid #ede9e9",
          }}
          collaborators={employees}
          onCancel={() => this.setState({ editMode: false })}
          data={data}
          actionPlan={actionPlan}
          onFinishSave={(result) => {
            onUpdateTask(result)
            this.setState({ editMode: false })
          }}
        />
      )
    }

    const dateTask = (
      <Fragment>
        <div className="ActionPlanTasks-component-detail-next-dates-title">
        {this.intl.actionPlanTaskForm.labels.taskScheduler}
        </div>
        <div
          className="ActionPlanTasks-component-detail-next-dates"
          style={{ maxHeight: 200, overflow: "auto" }}>
          {task_schedules.map((d, di) => (
            <Checkbox
              disabled={!canChangeStatus}
              onClick={() =>
                this.updateTaskStatus(2, d.id_task_schedule, !d.done)
              }
              checked={d.done}
              key={di}>
              {d.task_date}
            </Checkbox>
          ))}
        </div>
      </Fragment>
    )
    const nextDate = task_schedules.find((e) =>
      moment(moment(e.task_date, "DD/MM/YYYY")).isAfter(moment())
    )
    return (
      <div className="ActionPlanTasks-component">
        <div className="ActionPlanTasks-component-box">
          <div>
            <Tooltip
              placement="bottomLeft"
              overlayClassName="taskDoneArrow"
              title={
                !canChangeStatus
                  ? null
                  : data.done
                  ? "Marcar tarea como no completada"
                  : "Marcar tarea como completada"
              }>
              <div
                className={`ActionPlanTasks-component-box-check ${
                  data.done ? "complete" : ""
                }`}
                onClick={() => {
                  if (canChangeStatus)
                    this.updateTaskStatus(1, data.id_task, !data.done)
                }}
                style={{
                  cursor: canChangeStatus ? "pointer" : "default",
                  width: 20,
                  height: 20,
                }}
              />
            </Tooltip>
          </div>
          <div className="ActionPlanTasks-component-detail">
            <p>{data.name}</p>
          </div>
          <div className="ActionPlanTasks-component-calendar">
            <CalendarTwoTone twoToneColor="#AFAFAF" />
            <span style={{ color: data.active_date_red ? "#E37879" : null }}>
              {data.date_transform}
            </span>
          </div>
          <div className="ActionPlanTasks-component-progress">
            {data.periodicity !== 0 && (
              <ProgressBar
                custom={{
                  value: data.progress,
                  color: "#2BBA9A",
                  value_visible: `${data.progress}%`,
                }}
              />
            )}
          </div>
          {canEdit && (
            <div className="ActionPlanTasks-component-options">
              <Dropdown
                trigger={["click"]}
                placement="bottomRight"
                overlay={
                  <Menu>
                    <Menu.Item
                      onClick={(e) =>
                        this.setState({ editMode: true }, () => {
                          this.loadDetailsToEditTask()
                        })
                      }>
                      {this.intl.actionPlanTask.actions.edit}
                    </Menu.Item>
                    <Menu.Item onClick={() => this.props.onDelete()}>
                      {this.intl.actionPlanTask.actions.delete}
                    </Menu.Item>
                  </Menu>
                }>
                <img
                  style={{ cursor: "pointer", padding: 5 }}
                  src={pointMenu}
                />
              </Dropdown>
            </div>
          )}
        </div>
        {task_schedules.length > 1 && (
          <div className="ActionPlanTasks-component-detail-next">
            {nextDate && (
              <Fragment>
                <span>
                  <b>{this.intl.actionPlanTaskForm.labels.nextTask}</b>
                </span>
                <span>
                  <Checkbox
                    disabled={!canChangeStatus}
                    onClick={() =>
                      this.updateTaskStatus(
                        2,
                        nextDate.id_task_schedule,
                        !nextDate.done
                      )
                    }
                    checked={nextDate.done}>
                    {nextDate.task_date}
                  </Checkbox>
                </span>
              </Fragment>
            )}
            <div>
              <Popover
                placement="bottomLeft"
                content={dateTask}
                trigger="click">
                <span style={{ cursor: "pointer" }}>
                  {this.intl.actionPlanTaskForm.labels.showTasks} ({task_schedules.length})
                </span>
              </Popover>
            </div>
          </div>
        )}
        {data.employees && data.employees[0] && (
          <div
            className="ActionPlanTaskResumen-component-row"
            style={{ gridTemplateColumns: "30px auto" }}>
            <div />
            <div>
              <Avatar
                src={data.employees[0].picture_profile}
                size={20}
                style={{ display: "inline-block" }}
              />
              <span
                className="ActionPlanTaskResumen-component-row-name string_dots"
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  marginLeft: 5,
                }}>
                {data.employees[0].full_name}
              </span>
            </div>
            <div />
          </div>
        )}
      </div>
    )
  }
}

ActionPlanTask.propTypes = {}

export default ActionPlanTask
